module.exports = __webpack_public_path__ + "static/media/mve_video@3x.91a9acfa.png";